/**
 * The phone gallery uses the theme's own scroller. A sideways gesture moves
 * the next photograph, and the dots stay in step with that scroller.
 * Do not pin scrollLeft at max-width 749px.
 */
(function () {
  function bind(gallery) {
    if (gallery.dataset.jfFadeBound) return;
    gallery.dataset.jfFadeBound = '1';
  }

  function init() {
    document
      .querySelectorAll('.product-information media-gallery.media-gallery--carousel')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
